import { Link, Outlet } from "react-router";

import { ThemeControl } from "@/theme/theme-control";

import { Logo } from "../ui/logo";

// Give authentication the same warm archive identity as the product while
// keeping the verification task focused and readable.
export default function AuthLayout() {
  return (
    <main className="grid min-h-dvh lg:grid-cols-[1.05fr_0.95fr]">
      <section className="relative hidden overflow-hidden border-r p-12 lg:flex lg:flex-col">
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_25%_20%,color-mix(in_oklab,var(--secondary)_72%,transparent),transparent_38rem)]" />
        <div className="relative">
          <Logo linkTo="/" />
        </div>
        <blockquote className="relative mt-auto max-w-xl pb-8">
          <p className="font-serif text-4xl leading-tight font-semibold tracking-[-0.035em]">
            A private place for the moments that outlive the episode.
          </p>
          <footer className="text-muted-foreground mt-5 text-sm">
            Audio, notes, and progress in one personal archive.
          </footer>
        </blockquote>
      </section>

      <section className="flex min-h-dvh flex-col px-5 py-5 sm:px-8 sm:py-8">
        <div className="flex items-center justify-between lg:justify-end">
          <div className="lg:hidden">
            <Logo linkTo="/" />
          </div>
          <ThemeControl />
        </div>

        <div className="mx-auto flex w-full max-w-sm flex-1 items-center py-12">
          <div className="w-full">
            <Outlet />
          </div>
        </div>

        <p className="text-muted-foreground text-center text-xs">
          <Link className="underline-decoration underline" to="/privacy">
            Privacy
          </Link>{" "}
          ·{" "}
          <Link className="underline-decoration underline" to="/terms">
            Terms
          </Link>
        </p>
      </section>
    </main>
  );
}
